import { Logo } from "./Logo";

const links = [
  { label: "SERVICES", href: "#services", testid: "nav-services-link" },
  { label: "PROTOCOL", href: "#protocol", testid: "nav-protocol-link" },
  { label: "DEPLOY", href: "#deploy", testid: "nav-deploy-link" },
];

export const Header = () => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-obsidian/95 border-b border-olive-deep backdrop-blur-sm" data-testid="site-header">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
      <Logo />
      <nav className="hidden md:flex items-center gap-8" data-testid="main-nav">
        {links.map((l, i) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            className="text-xs tracking-[0.25em] text-muted-foreground hover:text-khaki transition-colors duration-300"
          >
            <span className="text-alert mr-1">0{i + 1}</span> {l.label}
          </a>
        ))}
      </nav>
      <a
        href="#deploy"
        data-testid="header-deploy-cta"
        className="dogtag bg-olive text-white text-xs font-bold tracking-[0.2em] px-5 py-2.5 hover:bg-khaki hover:text-obsidian transition-colors duration-300"
      >
        [ DEPLOY REQUEST ]
      </a>
    </div>
  </header>
);
